export default __webpack_public_path__ + "static/twitter-cover-photo-size-3cf468da72be98a126c66a9a5d959283.jpg";